<div class="checkout-container">
    <div class="payment-box">
        <!-- Linke Seite -->
        <div class="left">
            <h3>{{ 'sipo.payment-component.pay-component.credit-card' | translate }}</h3>

            <!-- Karteninhaber -->
            <div class="form-group">
                <label>{{ 'sipo.payment-component.pay-component.name-on-card' | translate }}</label>
                <input type="text" class="w-full mt-1"
                       [placeholder]="'sipo.payment-component.pay-component.name-on-card-placeholder' | translate"
                       [(ngModel)]="cardHolderName"/>
            </div>

            <!-- Kartennummer -->
            <div class="form-group">
                <label>{{ 'sipo.payment-component.pay-component.card-number' | translate }}</label>
                <div id="card-number-element" class="card-element"></div>
            </div>

            <!-- Ablauf + CVC nebeneinander -->
            <div class="form-row">
                <div class="form-group half">
                    <label>{{ 'sipo.payment-component.pay-component.card-validation' | translate }}</label>
                    <div id="card-expiry-element" class="card-element"></div>
                </div>
                <div class="form-group half">
                    <label>{{ 'sipo.payment-component.pay-component.cvc' | translate }}</label>
                    <div id="card-cvc-element" class="card-element"></div>
                </div>
            </div>

            <button class="btn-pay"
                    (click)="isPayCredit ? payCredit(): createPaymentMethod()" *ngIf="payButtonEnabled">{{ 'sipo.payment-component.buy-now' | translate }}
            </button>


<!--            <button class="btn-pay"-->
<!--                    (click)="isPayCredit ? payCredit(): pay()">{{ 'sipo.payment-component.buy-now' | translate }}-->
<!--            </button>-->

<!--            <button class="btn-pay"-->
<!--                    (click)="createPaymentMethod();">abo{{ 'sipo.payment-component.buy-now' | translate }}-->
<!--            </button>-->

<!--            <div class="divider">{{ 'sipo.payment-component.pay-component.or' | translate }}</div>-->

<!--            <button class="btn-paypal">{{ 'sipo.payment-component.pay-component.pay-with-paypal' | translate }}</button>-->
        </div>

        <!-- Rechte Seite -->
        <div class="right">
            <h3>{{ 'sipo.payment-component.order-overview' | translate }}</h3>
            <p>{{ 'sipo.payment-component.pay-component.price' | translate }} <span>{{ price | currencyFormat }}</span></p>
            <p>{{ 'sipo.payment-component.pay-component.vat' | translate }}<span>{{ tax | currencyFormat }}</span>
            </p>
            <hr/>
            <p>
                <strong>{{ 'sipo.payment-component.pay-component.total-amount' | translate }}</strong>
                <span>{{ amount | currencyFormat }}</span>
            </p>

            <div class="agb">
                <app-form-element
                    [formGroup]="formGroup"
                    [type]="FormTypes.CHECKBOX"
                    [formId]="'agb'"
                    [noLabel]="true"
                    class="agb-checkbox"
                >
                </app-form-element>

                <label for="agb" class="agb-label">
                    {{ 'sipo.payment-component.pay-component.terms-text-part-1' | translate }}
                    <a href="https://e-signatur24.de/agb" target="_blank">
                        {{ 'sipo.payment-component.pay-component.terms-text-part-2' | translate }}
                    </a>
                    {{ 'sipo.payment-component.pay-component.terms-text-part-3' | translate }}
                </label>
            </div>


            <div class="agb-wrapper mt-3">
                <!-- Fehlermeldung -->
                <p-message *ngIf="errorMessage"
                           severity="error"
                           [text]="errorMessage"
                ></p-message>
            </div>
        </div>
    </div>
</div>
